import { useCallback, useContext } from 'react';
import _ from 'lodash';

import cardTypeCheckers from '../../../../types/cardTypeCheckers';
import ReportGadgetsContext from '../../../../contexts/ReportGadgetsContext';
import ReportsContext from '../../../../contexts/ReportsContext';

import isUsedInChart from './isUsedInChart';

const useGetReportUsage = () => {
  const { reportGadgetsLookup } = useContext(ReportGadgetsContext);
  const { allReports } = useContext(ReportsContext);

  const getReportUsage = useCallback(
    (
      metric: Metrics.NormalMetric | Metrics.CompoundMetric,
    ): FleetOps.MetricReportUsage[] => {
      const usage = [] as FleetOps.MetricReportUsage[];
      allReports.forEach((r) => {
        r.canvas.cards.forEach((card) => {
          let chartDef: VisualisationDefinition | undefined;

          if (cardTypeCheckers.isChartDefinition(card)) {
            chartDef =
              reportGadgetsLookup[card.content.chartDefinitionId]?.chartDef;
          } else if (cardTypeCheckers.isReportGadget(card)) {
            chartDef =
              reportGadgetsLookup[card.content.reportGadgetId]?.chartDef;
          }

          if (!chartDef) {
            return;
          }

          if (isUsedInChart(metric, chartDef)) {
            usage.push({
              id: `${chartDef.id}-${r.id}`,
              gadgetName: chartDef.name,
              gadgetId: chartDef.id,
              reportId: r.id,
              reportName: r.name,
            });
          }
        });
      });

      return _.uniqBy(usage, 'id');
    },
    [allReports, reportGadgetsLookup],
  );

  return getReportUsage;
};

export default useGetReportUsage;
